import { useEffect, useState } from "react"
import { loadStationSheetReport, searchStation } from "./utils"
import References from "../../helpers/Reference"
import { AutoComplete, Button, Col, DatePicker, Dropdown, Flex, Row, Select, Space } from "antd"
import { DownOutlined } from "@ant-design/icons"
import { convertBlobFrom64, findIndexInJSONArray, saveFileDirectly } from "../../helpers/helpers"

import dayjs from 'dayjs'
import locale from "antd/es/date-picker/locale/ru_RU"
import AuthService from "../../helpers/auth"

const REPORT_TYPE_ITEMS = [
    {
        label: "Excel",
        value: "xlsx",
    },
    {
        label: "PDF",
        value: "pdf",        
    }
]

const REPORT_PERIOD_ITEMS = [
    {
        label: "День", 
        value: "day",
        format: "DD.MM.YYYY"
    },
    {
        label: "Месяц", 
        value: "month",
        format: "MM.YYYY"
    },
    {
        label: "Год", 
        value: "year",
        format: "YYYY"
    },

]

export const ReportSheet = ({onStartReport, onFinishReport}) => {

    const [stations, setStations] = useState({})
    const [station, setStation] = useState()

    const [mchs, setMchs] = useState([])
    const [mch, setMch] = useState([])    

    const [reportType, setReportType] = useState(REPORT_TYPE_ITEMS[0].value)
    const [reportPeriod, setReportPeriod] = useState(REPORT_PERIOD_ITEMS[0].value)

    const [date, setDate] = useState(dayjs().subtract(1, 'day').startOf('day'))

    const [stationOptions, setStationOptions] = useState([])    

    const [disabled, setDisabled] = useState(true)
    const [loading, setLoading] = useState(false)    

    useEffect(
        () => {
            loadStationSheetReport()
            .then(data => {
                setStations(data)
                setStationOptions(Object.keys(data).map(uuid => {
                    return {
                        uuid: uuid,
                        label: data[uuid].name,
                        value: uuid
                    }
                }))

            })
        }, 
    []
    )

    const onReport = () => {

        setLoading(true)
        setDisabled(true)
        onStartReport()

        const req = {
            "report_type": reportPeriod,
            "report_date": dayjs(date, References.dateTimeFormat).format(),
            "data_format": reportType,
            "station_uuid": station,
            "mch_kind": "mchs",
            "mch_type": mch.type,
            "mch_uuid": mch.uuid        
        }

        AuthService.post(References.api.report_sheet, req)
        .then(res => res.json())
        .then(data => saveFileDirectly(data.file_name, convertBlobFrom64(data.content_b64)))
        .catch(e => console.log(e.message))                    
        .finally(() => {
            setLoading(false)
            setDisabled(false)
            onFinishReport()
        })
    }

    const onStationSelect = (val) => {
        const mchs = stations[val]?.mchs
        setStation(val)
        setMchs(() => {
            const result = [];
            const types = Object.keys(mchs);
            types.forEach(type => {
                Object.keys(mchs[type]).forEach(mch => {
                    result.push({
                        label: mchs[type][mch].name,
                        uuid: mch,
                        value: mch,
                        type: type,
                    })
                }) 
            })
            setMch(result[0])
            return result
        })
        setDisabled(false)
    }

    const onMCHSelect = (_, option) => {
        setMch(option)
    }

    const onReportTypeSelect = ( item ) => {
        setReportType(item)
    }

    const onReportPeriodSelect = ( item ) => {
        setReportPeriod(item)
    }

    const onChangeDate = (date) => {
        setDate(date)
    }


    return (
        <>
            <div className="mt-2">
            <Select
                    options={stationOptions}
                    onChange={onStationSelect}
                    className="w-100"
                    placeholder={References.dictionary.station}
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }      
                    disabled={loading}             
                />                         
            </div>

            <div className="mt-2">
                <Select
                    options={mchs}
                    value={mch?.uuid}
                    onChange={onMCHSelect}
                    className="w-100"
                    placeholder={References.dictionary.mch}
                    disabled={loading || !station}
                />                         
            </div>

            <div className="mt-2">
                <Flex className="w-100">

                        <Select 
                            options={REPORT_TYPE_ITEMS}
                            defaultValue={reportType}
                            onChange={onReportTypeSelect}
                            className="w-100"
                            disabled={loading}             
                        />

                        <Select 
                            options={REPORT_PERIOD_ITEMS}
                            defaultValue={reportPeriod}
                            onChange={onReportPeriodSelect}
                            className="w-100 ml-2"
                            disabled={loading}             
                        />
                    </Flex>
            </div>

            <div className="mt-2">
            <DatePicker
                defaultValue={dayjs(date, References.dateFormat)}                
                onChange={onChangeDate}
                onOk={onChangeDate}
                format={REPORT_PERIOD_ITEMS[findIndexInJSONArray(REPORT_PERIOD_ITEMS, 'value', reportPeriod)].format}
                locale={locale}
                changeOnBlur
                inputReadOnly
                allowClear={false}
                className="w-100"
                picker={REPORT_PERIOD_ITEMS[findIndexInJSONArray(REPORT_PERIOD_ITEMS, 'value', reportPeriod)].value}
                disabled={loading}             
                />                
            </div>

            <div className="mt-2">
                <Button onClick={onReport} style={{width: "100%"}} type="primary" loading={loading} disabled={disabled}>Выполнить</Button>
            </div>

        </>
    )
}